import http from 'common/http'

export const fetchUbjUploadHistory = (
  pageSize: number,
  startDate?: string,
  endDate?: string,
  cursor?: string,
) => {
  const params = new URLSearchParams({ pageSize: String(pageSize) })
  if (startDate) params.set('startDate', startDate)
  if (endDate) params.set('endDate', endDate)
  if (cursor) params.set('cursor', cursor)
  return http.get(`/ubj/history?${params.toString()}`)
}

export const downloadUbjFile = (rxtime: string | number, year: number) => {
  const params = new URLSearchParams({
    rxtime: String(rxtime),
    year: String(year),
  })
  return http.get(`/ubj/download?${params.toString()}`, {
    responseType: 'blob',
  })
}

// Keep in sync with MAX_UBJ_ZIP_DOWNLOAD_FILES in packages/rest-api/routes/ubj.js
export const MAX_UBJ_ZIP_DOWNLOAD_FILES = 20

export type UbjZipDownloadFile = {
  rxtime: string | number
  year: number
}

export const downloadUbjFilesZip = (files: UbjZipDownloadFile[]) => {
  return http.post(
    '/ubj/download/zip',
    { files },
    { responseType: 'arraybuffer' },
  )
}
